// WebP 支持检测和降级处理

let webpSupported = null;
let checkPromise = null;

// 检测浏览器是否支持 WebP
export const checkWebpSupport = () => {
    if (checkPromise) return checkPromise;
    
    checkPromise = new Promise((resolve) => {
        if (webpSupported !== null) {
            resolve(webpSupported);
            return;
        }

        const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
        const img = new Image();
        
        img.onload = () => {
            webpSupported = img.width > 0 && img.height > 0;
            resolve(webpSupported);
        };
        
        img.onerror = () => {
            webpSupported = false;
            resolve(false);
        };
        
        img.src = webpData;
    });
    
    return checkPromise;
};

// 同步检测（用于已经检测过的情况）
export const isWebpSupported = () => webpSupported;

// 初始化检测
checkWebpSupport();

// 获取兼容的图片路径（用于已加载的图片URL）
// 如果浏览器不支持 webp，将 .webp 替换为 .png 或 .jpg
export const getCompatibleImageSrc = (webpSrc, fallbackExt = 'png') => {
    if (webpSupported === false && webpSrc && webpSrc.endsWith('.webp')) {
        return webpSrc.replace(/\.webp$/, `.${fallbackExt}`);
    }
    return webpSrc;
};

// 动态导入图片，带降级支持
export const importImage = async (webpImporter, pngImporter) => {
    await checkWebpSupport();
    
    if (webpSupported) {
        try {
            const module = await webpImporter();
            return module.default;
        } catch (e) {
            // webp 加载失败，尝试 png
            if (pngImporter) {
                const fallback = await pngImporter();
                return fallback.default;
            }
            throw e;
        }
    } else {
        // 不支持 webp，直接加载 png
        if (pngImporter) {
            const module = await pngImporter();
            return module.default;
        }
        // 没有 png 降级，尝试加载 webp（可能会失败）
        const module = await webpImporter();
        return module.default;
    }
};

